import debounce from "lodash.debounce";

window.ChartsStudents = new (function () {
  let params = {};

  this.initChart = () => {
    Object.assign(params, {
      student_id: $("#student-dashboard-student-id").text(),
      subject_name: $("#subject_name").val(),
      is_in_class: true,
      individual_exams: (() => { const f = document.getElementById("individual_exams"); return f ? Array.from(new FormData(f).getAll("individual_exams[]")) : []; })(),
    });

    if (params.student_id && params.subject_name && $("#chart-student").length) {
      buildChart(params);
    }
  };

  this.resizeChart = () => {
    var _onResizeWindowThrottled = debounce(() => ChartsStudents.initChart(), 500);
    $(window).on("resize", _onResizeWindowThrottled);
    $(".toggle-names-btn").on("click", _onResizeWindowThrottled);
  };

  this.bindExamChangeEvent = () => $(document).on("change", "#individual_exams", () => ChartsStudents.initChart());
  this.bindSubjectChangeEvent = () => $("#subject_form").on("ajax:success", () => ChartsStudents.initChart());

  function buildChart(val) {
    $.ajax({
      type: "GET",
      url: "/student_results",
      data: val,
      dataType: "json",
      success: function (data) {
        let objects = data.objects;
        let isSubjectsShown = data.subjects_shown;
        if (Array.isArray(objects) && objects.length > 0) {
          Shared.drawStudentChart({
            objects,
            isSubjectsShown,
            containerElementId: "chart-student",
          });

          $(".chart-student").show();
        } else {
          $(".chart-student").hide();
        }
        StudentDashboard.setHeight();
      },
      error: function (data) {
        console.log(data.errors);
      },
    });
  }
})();
